// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

import debugModule from "debug";
/**
 * @internal
 * log statements for linkEntity
 */
export const link = debugModule("azure:service-bus:linkEntity");
/**
 * @internal
 * log statements for error
 */
export const error = debugModule("azure:service-bus:error");
/**
 * @internal
 * log statements for warning
 */
export const warning = debugModule("azure:service-bus:warning");
/**
 * @internal
 * log statements for management
 */
export const mgmt = debugModule("azure:service-bus:management");
/**
 * @internal
 * log statements for sender
 */
export const sender = debugModule("azure:service-bus:sender");
/**
 * @internal
 * log statements for receiver
 */
export const receiver = debugModule("azure:service-bus:receiver");
/**
 * @internal
 * log statements for receiverbatching
 */
export const batching = debugModule("azure:service-bus:receiverbatching");
/**
 * @internal
 * log statements for receiverstreaming
 */
export const streaming = debugModule("azure:service-bus:receiverstreaming");
/**
 * @internal
 * log statements for connectionContext
 */
export const connectionCtxt = debugModule("azure:service-bus:connectionContext");
/**
 * @internal
 * log statements for clientEntityContext
 */
export const entityCtxt = debugModule("azure:service-bus:clientEntityContext");
/**
 * @internal
 * log statements for namespace
 */
export const ns = debugModule("azure:service-bus:namespace");
/**
 * @internal
 * log statements for servicebusMessage
 */
export const message = debugModule("azure:service-bus:servicebusMessage");
/**
 * @internal
 * log statements for map
 */
export const map = debugModule("azure:service-bus:concurrentMap");
/**
 * @internal
 * log statements for utils
 */
export const utils = debugModule("azure:service-bus:utils");
/**
 * @internal
 * log statements for messageSession
 */
export const messageSession = debugModule("azure:service-bus:messageSession");
/**
 * @internal
 * log statements for semaphore
 */
export const semaphore = debugModule("azure:service-bus:semaphore");
/**
 * @internal
 * log statements for sessionManager
 */
export const sessionManager = debugModule("azure:service-bus:sessionManager");
/**
 * @internal
 * log statements for Atom XML management API over HTTP
 */
export const httpAtomXml = debugModule("azure:service-bus:atom-xml");
